import { classnames } from '@weapp/utils';
import { observer } from 'mobx-react';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { clsPrefix } from '../../constants';
import './index.less';
import multiRoutePageStore from './Store';
import LocationRoute from '../../hocs/LocationRoute';

interface RoutePageProps extends RouteComponentProps, React.Attributes {
  id: string;
}

const RoutePage = withRouter(
  LocationRoute(observer((props: RoutePageProps) => {
    const { id } = props;
    const { activePageKey, renderPage } = multiRoutePageStore;
    const active = activePageKey === id;

    return (
      <div key={id} className={classnames(`${clsPrefix}-page`, { active })}>
        {renderPage(id)}
      </div>
    );
  })),
) as any;

const MultiPage: React.FC<React.Attributes> = (props) => {
  const { pageKeys, appId } = multiRoutePageStore;
  const currentPageKeys = pageKeys[appId] || [];

  /**
   * 由于MultiPage放在了外层路由同级，而RoutePage是放在了下一级路由中
   * 故此处还需用Route包裹一层，确保页面内部组件获取的router相关的props不会出错
   * 根据应用id渲染，以防止切换应用会渲染不必要的页面
   * */
  return (
    <>
      {currentPageKeys.map((id, index) => (
        <RoutePage key={id} weId={`${props.weId || ''}_prwlmb@${index}`} id={id} />
      ))}
    </>
  );
};

export default observer(MultiPage);
